import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-not-authorized',
    imports: [RouterLink, MatCardModule, MatButtonModule],
    templateUrl: './not-authorized.component.html',
    styleUrl: './not-authorized.component.scss'
})
export class NotAuthorizedComponent {}